import Head from "next/head";
import { FC } from "react";

const SiteHeadTags: FC = () => {
  return (
    <Head>
      <link rel="manifest" href="/pwa/manifest.json" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="FaraDars (PWA)" />

      <link rel="apple-touch-icon" sizes="64x64" href="/pwa/64.png" />
      <link rel="apple-touch-icon" sizes="128x128" href="/pwa/128.png" />
      <link rel="apple-touch-icon" sizes="256x256" href="/pwa/256.png" />
      <link rel="apple-touch-icon" sizes="512x512" href="/pwa/512.png" />
      <link rel="apple-touch-icon" sizes="1024x1024" href="/pwa/1024.png" />
      <link rel="apple-touch-icon" href="/pwa/512.png" />

      <meta
        name="google-site-verification"
        content="J8oLschRwQx5N4uhnOQqtiXJj5fQ09Go5q9byGV4zIE"
      />
      <meta
        name="google-site-verification"
        content="nqaV66dECEM8jgbVrzQlrb90j3AP6zRPXUJZ9bj4tL4"
      />
    </Head>
  );
};

export default SiteHeadTags;
